import { Location } from "../utils/response";

export const enum LocationReducerActionType {
  CLEAR = 'CLEAR',
  UPDATE = 'UPDATE',
  UPDATE_ADDRESS = 'UPDATE_ADDRESS',
}

export interface LocationData extends Location {
  address?: string;
}

export interface LocationReducerAction {
  type: LocationReducerActionType;
  payload?: {uid: string, location: LocationData };
}

export interface LocationState {
  [uid: string]: LocationData
}

export const locationReducer = (state: LocationState, action: LocationReducerAction) => {
  const { type, payload } = action;
  switch(type) {
    case LocationReducerActionType.CLEAR:
      return {};
    case LocationReducerActionType.UPDATE:
      // payload!.data.location.latitude = payload!.data.location.latitude ? payload!.data.location.latitude - Math.random()/100 : -1;
      // payload!.data.location.longitude = payload!.data.location.longitude ? payload!.data.location.longitude - Math.random()/100 : -1;
      return { ...state, [payload!.uid]: payload!.location };
    case LocationReducerActionType.UPDATE_ADDRESS:
      return { ...state, [payload!.uid]: { ...state[payload!.uid], ...payload!.location } };
    default:
      return state;
  }
};
